import moment from "moment";

export default {
  updateReportList: function (state, payload) {
    state.reportList = payload;
  },
  updateLoading(state, payload) {
    state.loading = payload;
  },
};
